import React, { useState } from 'react';
import './card-update-pin-form.scss';
import { Form, FormValidationMode } from '@ampol/design-system';
import * as yup from 'yup';
import Validation from 'constants/validation-messages';
import Regex from 'constants/regex';

const CardUpdatePinForm = ({ onValidation, readOnly, formId, onSubmit }) => {
  const [isValid, setisValid] = useState(false);

  const pinValidation = yup.string()
    .required(Validation.PIN_REQUIRED)
    .nullable().transform((value, originalValue) => (originalValue === '' ? null : value))
    .min(4, Validation.MIN_FOUR_MAX_SIX)
    .max(6, Validation.MIN_FOUR_MAX_SIX)
    .matches(Regex.ONLY_NUMBERS, Validation.ONLY_NUMBERS);
    
  const validationSchema = yup.object().shape({
    newPin: pinValidation,
    confirmNewPin: pinValidation.oneOf([yup.ref('newPin')], Validation.CONFIRM_PIN),
  });

  const handleStateChange = ({ isValid }) => {
    onValidation && onValidation(isValid);
    setisValid(isValid);
  };

  return <div className={'card-update-pin'}>
    <Form
      id={formId}
      schema={validationSchema}
      onStateChange={handleStateChange}
      validationMode={FormValidationMode.onChange}
      onSubmit={onSubmit}
      triggerValidation={isValid}
    >
      <div className={'card-update-pin__fields'}>
        <Form.Input label={'New PIN'} name={'newPin'} maxLength={6} disabled={readOnly} />
        <Form.Input label={'Confirm PIN'} name={'confirmNewPin'} maxLength={6} disabled={readOnly} />
      </div>
    </Form>
  </div>;
};

export default CardUpdatePinForm;

